(function () {
  function qsAll(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-boitoi-reader-close]');
    if (close) close.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-boitoi-reader-open]');
    if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-boitoi-reader-open')); return; }
    var closer = e.target.closest('[data-boitoi-reader-close]');
    if (closer) { e.preventDefault(); closeModal(closer.closest('.boitoi-reader-modal')); return; }
    if (e.target.classList && e.target.classList.contains('boitoi-reader-modal')) closeModal(e.target);
    var theme = e.target.closest('[data-reader-theme-choice]');
    if (theme) {
      var modal = theme.closest('.boitoi-reader-modal');
      var body = modal && modal.querySelector('.boitoi-reader-inline');
      if (body) {
        body.setAttribute('data-reader-theme', theme.getAttribute('data-reader-theme-choice'));
        qsAll('[data-reader-theme-choice]', modal).forEach(function (b) { b.classList.toggle('is-active', b === theme); });
      }
    }
    var size = e.target.closest('[data-reader-font]');
    if (size) {
      var modal2 = size.closest('.boitoi-reader-modal');
      var body2 = modal2 && modal2.querySelector('.boitoi-reader-inline');
      if (body2) {
        var current = parseFloat(window.getComputedStyle(body2).fontSize) || 18;
        var delta = size.getAttribute('data-reader-font') === 'up' ? 1 : -1;
        current = Math.max(14, Math.min(28, current + delta));
        body2.style.fontSize = current + 'px';
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal(document.querySelector('.boitoi-reader-modal.is-open'));
  });
})();
